// TODO: Remove this component. Will get tokens image from the backend
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TokenIcons from 'components/Common/Icons/TokenIcons/TokenIcons';
import ShowsAt from '../../ShowAt/ShowAt';
import Tooltip from '../../Tooltip/Tooltip';
import './Coins.scss';

const Coins = ({ coins = [] }) => {
  const maxShown = 5;
  const coinsWithImgs = useMemo(() => coins.filter((coin) => coin?.image), [coins]);

  const shownCoions = coinsWithImgs.slice(0, maxShown);
  const hiddenLength = coinsWithImgs.length - maxShown;

  return (
    <ShowsAt at={!!coins?.length}>
      <div className="pool-lengend-coins">
        <div className="coins">
          {shownCoions.map(({ name, image }, index) => (
            <Tooltip key={name} text={name}>
              <TokenIcons name={name} image={image} style={{ marginLeft: index ? '-8px' : '' }} />
            </Tooltip>
          ))}
        </div>
        {hiddenLength > 0 && <div className="more">+{hiddenLength}</div>}
      </div>
    </ShowsAt>
  );
};
Coins.defaultProps = {
  coins: [],
};
Coins.propTypes = {
  coins: PropTypes.array,
};

export default Coins;
